itsoftApp.createModule("filters", function () {
    var module = this;

    var initFilters = function (form) {
        var URL = "./"; // ./
        var checkboxes = form.querySelectorAll("input[type='checkbox']");
        var hiddenInputs = form.querySelectorAll("input[type='hidden']");
        var filterTop = document.querySelector(".js-filter-top");
        var pageTagsElement = document.querySelector(".page__tags");
        var submitButtonElement = form.querySelector("[type='submit']");
        var resetButtonElement = form.querySelector("[type='reset']");
        var filterIconWrapper = document.querySelector(".filters__icon-wrapper");
        var sliderRangeElements = form.querySelectorAll(".js-range");
        var tagsSection = document.querySelector(".js-filter-tags");
        if (tagsSection) {
            var tagElements = tagsSection.querySelectorAll(".page__tag");
        }
        var currentType = "";
        var currentBrand = "";
        var allInputs = document.querySelectorAll("[data-filter]");
        var closeIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.142578" y="1.42896" width="1.33333" height="20" transform="rotate(-45 0.142578 1.42896)"/><rect x="14.1426" y="0.428955" width="1.33333" height="20" transform="rotate(45 14.1426 0.428955)"/></svg>';
        var filterAjaxUrl = "";
        var filters = "";
        var tagRemoved = false;

        var setDefaultURL = function () {
            var currentURL = location.href;
            var defaultURL = currentURL;
            var filterPosition = currentURL.indexOf("filter");

            if (filterPosition !== -1) {
                defaultURL = currentURL.substring(filterPosition, 0);
            }

            location.href = defaultURL;
        }

        var resetForm = function () {
            form.reset();
            if (sliderRangeElements) {
                Array.prototype.forEach.call(sliderRangeElements, function (rangeWrapper) {
                    var sliderRangeElement = rangeWrapper.querySelector(".js-range-element");
                    var rangeMinInput = rangeWrapper.querySelector(".filters__input-min");
                    var rangeMaxInput = rangeWrapper.querySelector(".filters__input-max");
                    rangeMinInput.value = sliderRangeElement.getAttribute("data-range-min");
                    rangeMaxInput.value = sliderRangeElement.getAttribute("data-range-max");
                    sliderRangeElement.noUiSlider.reset();
                });
            }
            setDefaultURL();
        }

        if (sliderRangeElements) {
            Array.prototype.forEach.call(sliderRangeElements, function (rangeWrapper) {
                var sliderRangeElement = rangeWrapper.querySelector(".js-range-element");
                var rangeMinInput = rangeWrapper.querySelector(".filters__input-min");
                var rangeMaxInput = rangeWrapper.querySelector(".filters__input-max");

                sliderRangeElement.noUiSlider.on("change", function (values, handle) {
                    rangeMinInput.value = "" + values[0];
                    rangeMaxInput.value = "" + values[1];
                    filter();
                    var data = "ajax=y" + filters;
                    sendRequest(data, updatePage);
                });
            });
        }


        var updateCheckbox = function (data) {
            var dataObject = data; //JSON.parse(data);
            if (dataObject) {
                var keys = Object.keys(dataObject["AVAILABLE_PROPERTIES"]);
                Array.prototype.forEach.call(checkboxes, function (checkbox) {
                    checkbox.disabled = true;
                });

                Array.prototype.forEach.call(keys, function (key) {
                    var checkboxActive = form.querySelector('[name="' + key + '"]');

                    if (checkboxActive) {
                        checkboxActive.disabled = false;
                    }
                });
            }
        }

        var updatePage = function (data) {
            updateCheckbox(data);
            submitButtonElement.setAttribute("data-filter-ajax-url", data["FILTER_AJAX_URL"]);
            // resetButtonElement.classList.remove("js-hide");
            filterIconWrapper.classList.remove("js-hide");
            if (tagRemoved) {
                var filterAjaxUrl = submitButtonElement.getAttribute("data-filter-ajax-url");
                location.href = filterAjaxUrl;
            }
        }

        var removeTag = function (evt) {
            evt.preventDefault();
            var tag = evt.currentTarget;
            var controlId = tag.getAttribute("data-control-id");

            if (controlId) {
                var checkbox = form.querySelector("#" + controlId);

                if (checkbox) {
                    tagRemoved = true;
                    checkbox.checked = false;
                    onCheckboxChange();
                }
            }
        }

        var sendRequest = function (data, onSuccess) {
            BX.ajax.loadJSON(
                URL,
                data,
                onSuccess
            );
        }

        var onSubmitButtonClick = function (evt) {
            evt.preventDefault();
            filterIconWrapper.classList.remove("js-hide");
            itsoftApp.modules.animateScroll.callback(filterTop);
            var filterAjaxUrl = submitButtonElement.getAttribute("data-filter-ajax-url");
            location.href = filterAjaxUrl;
        }

        var onResetButtonClick = function (evt) {
            evt.preventDefault();
            resetForm();
        }

        var filter = function () {
            submitButtonElement.setAttribute("data-filter-ajax-url", "");
            filters = "";

            if (hiddenInputs) {
                Array.prototype.forEach.call(hiddenInputs, function (input) {
                    var name = input.getAttribute("name");
                    var value = input.value; 
                    var defaultValue = input.getAttribute("data-default-value");
                    if (value !== defaultValue) {
                        filters += "&" + name + "=" + value;
                    }
                });
            }

            Array.prototype.forEach.call(checkboxes, function (checkbox) {
                if (checkbox.checked) {
                    var name = checkbox.getAttribute("name");
                    var value = "Y";
                    filters += "&" + name + "=" + value;
                }
            });
        }

        var onCheckboxChange = function (evt) {
            filter();
            var data = "ajax=y" + filters;
            sendRequest(data, updatePage);
        }

        Array.prototype.forEach.call(checkboxes, function (checkbox) {
            checkbox.addEventListener("change", onCheckboxChange);
        });

        submitButtonElement.addEventListener("click", onSubmitButtonClick);
        if (resetButtonElement) {
            resetButtonElement.addEventListener("click", onResetButtonClick);
        }

        if (tagElements) {
            Array.prototype.forEach.call(tagElements, function (tag) {
                tag.addEventListener("click", removeTag);
            });
        }
    }

    module.callback = initFilters;
});